<!-- 植被管理，bluesky:2023-10-04 -->
<template>
  <div class="manage-section">

    <div class="breadcrumb-wrap">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>管理后台</el-breadcrumb-item>
        <el-breadcrumb-item>植被管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 搜索-start -->
    <div class="search-wrap">

      <div class="search-item">
          <div class="btn-list-wrap">
              <el-button type="info" @click="clickAdd">添加</el-button>
          </div>
      </div>

      <div class="search-item">
        <label for="areaSelect">类型：</label>
        <el-select @change="changeType" v-model="search.type" placeholder="请选择">
            <el-option
              v-for="item in typeList"
              :key="item.value"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
      </div>

      <div class="search-item">
        <label class="label" for="keyword">关键词：</label>
        <el-input placeholder="请输入关键词" id="keyword" v-model="search.keyword" @keyup.enter.native="clickSearch"></el-input>
      </div>
      <div class="search-item">
        <el-button type="primary" @click="clickSearch">搜索</el-button>
      </div>
      <div class="search-item mt10">
        <label class="label">适宜种植月份：</label>
        <el-checkbox-group v-model="search.suitableMonthList" @change="changeMonthList">
          <el-checkbox v-for="(item,index) in 12" :key="index"
          :label="item">{{item}}月</el-checkbox>
        </el-checkbox-group>
      </div>
    </div>
    <!-- 搜索-end -->

    <!-- 表格-start -->
    <div class="table-wrap">
        <el-table
          :data="tableData"
          border
          style="width: 100%">
          <el-table-column
            prop="id"
            label="编号"
            >
          </el-table-column>
          <el-table-column
            prop="name"
            label="植被名称"
            >
          </el-table-column>
          <el-table-column
            prop="type"
            label="类型">
            <template slot-scope="{row}">
            	<div>{{row.type == 0 ? "树种" : (row.type == 1 ?"草种":"")}}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="suitableMonthList"
            label="适宜种植月份"
            >
          </el-table-column>
          <el-table-column
            prop="description"
            label="说明"
            >
          </el-table-column>
          <!-- <el-table-column
            prop="showOrder"
            label="显示顺序"
            >
          </el-table-column> -->

          <el-table-column
            prop="createTime"
            label="添加时间"
            >
          </el-table-column>
          <el-table-column
            prop="updateTime"
            label="修改时间"
            >
          </el-table-column>
          <el-table-column
          	label="状态">
          	<template slot-scope="{row}">
          		{{ row.status == 1 ? "启用": "停用"}}
          	</template>
          </el-table-column>
          <el-table-column
          	label="操作">
              <template slot-scope="{row}">
                  <div class="flex-center operate">
                      <!-- <el-button type="info" size="mini" @click="clickToggle(row.id,row.status)">{{ row.status == 1?"停用":"启用" }}</el-button> -->
                      <el-button type="info" size="mini" @click="clickEdit(row.id)">修改</el-button>
                      <el-button type="info" size="mini" @click="clickDelete(row.id)">删除</el-button>
                  </div>
              </template>
          </el-table-column>
        </el-table>

       <div class="pager-wrap">
         <el-pagination
             background
             layout="prev, pager, next"
         	@current-change="pageChange"
             :page-size="search.pageSize"
                :total="totalCount">
         </el-pagination>
       </div>

    </div>
    <!-- 表格-end -->

    <el-dialog :visible.sync="isShowPopup" width="800px">
    	<div class="popup-title" slot="title">{{idInput?'修改':'添加'}}植被</div>
    	<addOrEditTree :idInput="idInput" @close="closePopup" @success="finishPublish" v-if="isShowPopup"></addOrEditTree>
    </el-dialog>

  </div>
</template>

<script>
  import addOrEditTree from '@/page/components/addOrEditTree.vue';
  export default {
    components:{
      addOrEditTree,// 添加/修改植被
    },
    data() {
      return {
        search:{
          keyword:null,// 关键词
          type:null,// 类型
          suitableMonthList:[],// 适宜种植月份
          pageSize:10,// 每页显示数量
          pageIndex:1,// 页码
        },
        totalCount:0,// 总数量
        totalPageCount:0,//总页码数

        typeList:[{
          name:'请选择',
          value:null
        },{
          name:'树种',
          value:0
        },{
          name:'草种',
          value:1
        }],

        monthList:[1,2,3,4,5],

        tableData: [],

        isShowPopup:false,// 是否显示弹窗
        idInput:null,// 修改时传入ID
      }
    },
    mounted() {
      this.getList();
    },
    methods:{
      //改变页码
      pageChange(pageIndex){
      	this.search.pageIndex = pageIndex;
      	this.getList();
      },
      // 改变月份
      changeMonthList(){
        this.search.pageIndex = 1;
        this.getList();
      },
      // 改变类型
      changeType(){
        this.search.pageIndex = 1;
        this.getList();
      },
      // 点击搜索
      clickSearch(){
        this.search.pageIndex = 1;
        this.getList();
      },
      //获取列表
      getList(){
      	this.$apis.post('/admin/tree/page', this.search).then(res => {
      		console.log("res",res);
          if(res.data.code == 200){
      			this.tableData = res.data.data.list;
      			this.totalPageCount = res.data.data.totalPageCount;
            this.totalCount = res.data.data.totalCount;
      		}
      		else{
      			this.$message({
      			    message:res.data.data,
      			    type:'error'
      			});
      		}
      	});
      },

                //添加
                clickAdd(){
                	this.isShowPopup = true;
                	this.idInput = null;
                },
                //修改
                clickEdit(id){
                	this.isShowPopup = true;
                	this.idInput = id;
                },
                //启用、停用
                clickToggle(id,oldStatus){
                	this.$confirm(`你确定要继续吗？`, '提示', {
                		confirmButtonText: '确定',
                		cancelButtonText: '取消',
                		type: 'warning'
                	}).then(() => {
                		this.$apis.post('/admin/tree/toggle', {
                			id:id,
                      status:oldStatus == 1 ? 0 : 1,
                		}).then((res) => {
                			if (res.data.code == 200) {
                				this.getList();
                				this.$message.success('操作成功！');
                			}
                			else{
                				this.$message({
                				    message:res.data.data,
                				    type:'error'
                				});
                			}
                		})
                	}).catch(() => {});
                },
                // 删除
                clickDelete(id){
                	this.$confirm(`你确定要继续吗？`, '提示', {
                		confirmButtonText: '确定',
                		cancelButtonText: '取消',
                		type: 'warning'
                	}).then(() => {
                		this.$apis.get('/admin/tree/delete', {
                			id:id,
                		}).then((res) => {
                			if (res.data.code == 200) {
                				this.getList();
                				this.$message.success('操作成功！');
                			}
                			else{
                				this.$message({
                				    message:res.data.data,
                				    type:'error'
                				});
                			}
                		})
                	}).catch(() => {});
                },
                //完成添加/修改操作后的回调
                finishPublish(){
                	this.isShowPopup = false;
                	this.getList();
                },
                //关闭弹窗
                closePopup(){
                	this.isShowPopup = false;
                },


                },
  }
</script>

<style type="scss">

</style>



// WEBPACK FOOTER //
// src/page/treeManage.vue